
<tui-root>
  @if (loadingService.isStateLoading(loadingService.StatesNames.GET_ME)){
    <app-preloader></app-preloader>

  }
  <router-outlet/>
</tui-root>
